import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "shift-info-layout" }
const _hoisted_2 = {
  key: 0,
  class: "shift-info-preloader"
}
const _hoisted_3 = { class: "shift-info-head" }
const _hoisted_4 = { class: "shift-info-row" }
const _hoisted_5 = { class: "shift-info-vs" }
const _hoisted_6 = { class: "shift-info-employee" }
const _hoisted_7 = { class: "shift-info-table" }
const _hoisted_8 = { class: "shift-info-type" }
const _hoisted_9 = {
  key: 0,
  class: "shift-info-timedate"
}
const _hoisted_10 = {
  key: 1,
  class: "shift-info-timedate"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "wide-cell"
}
const _hoisted_15 = { colspan: "3" }
const _hoisted_16 = { class: "shift-info-desc" }
const _hoisted_17 = {
  key: 0,
  class: "sub-cell"
}
const _hoisted_18 = { class: "shift-info-desc" }
const _hoisted_19 = {
  key: 2,
  class: "shift-info-preloader"
}

import { addHours, format, parseISO } from 'date-fns';
import { ru } from 'date-fns/locale';
import { ShiftInfoItem, TimeRange } from '@/types';
import { computed, onBeforeMount, ref } from 'vue';
import loaderJSON from '@/static/img/preloader-web-blue.json';
import { Vue3Lottie } from 'vue3-lottie';
import store from '@/store';

interface Props {
  shiftId: string
  timeShift: TimeRange[] | undefined
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaShiftInfo',
  props: {
    shiftId: {},
    timeShift: {}
  },
  setup(__props: any) {

const props = __props

const isLoading = ref(false)
const error = ref('')
let loaderTimer: ReturnType<typeof setTimeout> | null = null
const shiftInfo = computed(() => {
  return store.getters["data/shiftInfo"];
});

// Находим открытую смену в этом дне
const getTimeZoneById = (array: TimeRange[], id: string) => {
  const item = array.find(obj => obj.id === id);
  return item?.timeZone ?? 0;
};

// Смещение таймзоны из текущей открытой смены
const timeZoneOffset = computed(() => {
  return props.timeShift ? getTimeZoneById(props.timeShift, shiftInfo.value.shiftId) : 0;
});

// Описание типов смен
const getShiftStatus = (shiftStatus: string) => {
  if (!shiftStatus) return false

  switch (shiftStatus) {
    case 'New': return 'Новая';
    case 'Active': return 'Активная';
    case 'Done': return 'Завершенная';
    case 'Miss': return 'Невыход';
    case 'Canceled': return 'Отмененная';
    case 'MissAccepted': return 'Невыход согласован';
  }
}

// Форматирование дат
const dateFormats = {
  date: 'dd.MM.yyyy',
  time: 'HH:mm:ss',
  localTime: 'HH:mm:ss',
} as const;

const formatDateTime = (date: string, formatType: keyof typeof dateFormats, useTimeZoneOffset = true) => {
  if (!date) return;
  const dateObj = new Date(date);
  const adjustedDate = useTimeZoneOffset ? addHours(dateObj, timeZoneOffset.value) : dateObj;
  return format(adjustedDate, dateFormats[formatType], { locale: ru });
};

const formatDate = (date: string) => formatDateTime(date, 'date');
const formatTime = (date: string) => formatDateTime(date, 'time');
const formatLocalTime = (date: string) => formatDateTime(date, 'localTime', false);

const formatShiftDates = (dateFrom: string, dateTo: string) => {
  if (!dateFrom) return
  const from = getDate(dateFrom)
  const to = getDate(dateTo)
  return from === to ? from : `${from} - ${to}`
}

const getFullName = (entry: ShiftInfoItem) => [entry.lastName, entry.firstName, entry.middleName].filter(Boolean).join(' ')

const getDate = (isoDate: string) => {
  const parsedDate = parseISO(isoDate)
  return format(parsedDate, 'dd.MM.yyyy')
}

const getShiftInfo = async () => {
  try {
    // Показываем загрузку если данные не пришли за 200 мс
    loaderTimer = setTimeout(() => {
      isLoading.value = true;
    }, 200)

    if (props.shiftId) {
      await store.dispatch("data/getShiftInfo", props.shiftId)
    }
  } catch (e) {
    console.error(e);
  } finally {
    if (loaderTimer) {
      clearTimeout(loaderTimer)
      loaderTimer = null
    }
    isLoading.value = false;

    // Пишем ошибку если не прошёл запрос (или нет данных) и закончилась загрузка
    if (!isLoading.value && !shiftInfo.value) {
      error.value = `Данные не найдены`
    }
  }
}

onBeforeMount(() => {
  getShiftInfo()
})

return (_ctx: any,_cache: any) => {
  const _component_vita_icon = _resolveComponent("vita-icon")!
  const _component_perfect_scrollbar = _resolveComponent("perfect-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(Vue3Lottie), {
            class: "animate",
            animationData: _unref(loaderJSON),
            width: "140px",
            height: "140px"
          }, null, 8, ["animationData"])
        ]))
      : (shiftInfo.value)
        ? (_openBlock(), _createBlock(_component_perfect_scrollbar, {
            key: 1,
            class: "shift-info-scroll rail-thin rail-gap-vertical"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Основная смена", -1)),
                  _createElementVNode("div", {
                    class: _normalizeClass(["shift-info-status", shiftInfo.value.shiftStatus])
                  }, _toDisplayString(getShiftStatus(shiftInfo.value.shiftStatus)), 3)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[1] || (_cache[1] = _createElementVNode("span", null, "Вита Система забрала данные", -1)),
                    (shiftInfo.value.isGotVs)
                      ? (_openBlock(), _createBlock(_component_vita_icon, {
                          key: 0,
                          name: "checked-green"
                        }))
                      : (_openBlock(), _createBlock(_component_vita_icon, {
                          key: 1,
                          name: "cross-red"
                        }))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(getFullName(shiftInfo.value)) + " (" + _toDisplayString(shiftInfo.value.position) + " " + _toDisplayString(shiftInfo.value.bid) + ") " + _toDisplayString(formatShiftDates(shiftInfo.value.dateFrom, shiftInfo.value.dateTo)), 1),
              _createElementVNode("table", _hoisted_7, [
                _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Действия по смене"),
                    _createElementVNode("th", null, "Значения по смене"),
                    _createElementVNode("th", null, "ФИО / должность сотрудника")
                  ])
                ], -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shiftInfo.value.shiftStatusItems, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createElementVNode("tr", {
                      class: _normalizeClass(item.type)
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(item.label), 1),
                        (item.createdAt)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createElementVNode("div", null, _toDisplayString(formatLocalTime(item.createdAt)), 1),
                              _createElementVNode("div", null, _toDisplayString(formatDate(item.createdAt)), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_10, "—"))
                      ]),
                      _createElementVNode("td", null, [
                        (item.dateFrom || item.dateTo)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, " с " + _toDisplayString(formatTime(item.dateFrom)) + " до " + _toDisplayString(formatTime(item.dateTo)), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_12, "—"))
                      ]),
                      _createElementVNode("td", null, [
                        (getFullName(item))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(getFullName(item)) + " /", 1))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(item.position), 1)
                      ])
                    ], 2),
                    (item.type === 'cancelled')
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                          _createElementVNode("td", _hoisted_15, [
                            _createElementVNode("div", null, [
                              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "shift-info-type" }, "Причина отмены:", -1)),
                              _createElementVNode("div", _hoisted_16, _toDisplayString(item.cancelationReason || '—'), 1)
                            ]),
                            (item.cancelationComment)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "shift-info-type" }, "Комментарий отмены:", -1)),
                                  _createElementVNode("div", _hoisted_18, _toDisplayString(item.cancelationComment), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", null, _toDisplayString(error.value), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})